<template>
  <div v-if="notification && notification.type === 'INVOICE_DEPOSIT'">
    <span></span>Сумма <strong>{{ amount }}</strong> {{ currency }}. была успешно <u>перечислена</u> на счет <strong>{{ invoice }}</strong>.
  </div>
</template>

<script>
  import utils from '../../../utils';
  import { mapGetters } from 'vuex';

  export default {
    name: 'NotificationInvoiceDeposit',
    computed: {
      ...mapGetters(['notification', 'currency']),
      invoice() {
        return utils.formatInvoice(this.notification.invoice);
      },
      amount() {
        return utils.convertSystemToCurrency(this.notification.amount, this.currency);
      }
    },
  }
</script>

<style scoped>
  div {
    margin-top: 10px;
    padding: 0.7em;
    border: 1px solid #add978;
    background: #d3f2c0;
    color: #333;
    border-radius: 6px;
    font-family: Verdana, sans-serif;
    font-size: 11px;
  }

  span {
    float: left;
    margin-right: 0.3em;
    width: 16px;
    height: 16px;
    display: block;
    text-indent: -99999px;
    overflow: hidden;
    background: url(../../../assets/ui-icons_2e83ff_256x240.png) no-repeat -208px -192px;
  }
</style>

